(function jQuery(global) {
  // @ts-ignore
  global.$ = $;
  // @ts-ignore
  global.jQuery = $;
}(typeof window !== 'undefined' ? window : this));
